import type { CURRENCY } from "constants/currencies";
import type { ObjectValuesAsTypes } from "utils/types";

import type { ALL_TAG_TYPE } from "../constants/Filters";

export const AMOUNT_FILTER_KEYS = {
  AMOUNT_FROM: "amountFrom",
  AMOUNT_TO: "amountTo",
} as const;

export type AmountFilterContext = {
  [AMOUNT_FILTER_KEYS.AMOUNT_FROM]: number | null;
  [AMOUNT_FILTER_KEYS.AMOUNT_TO]: number | null;
};
export type AmountFilterWithCurrencyContext = AmountFilterContext & {
  currency: CurrencyFilterValue[];
};

export type CurrencyFilterValue =
  | ALL_TAG_TYPE
  | ObjectValuesAsTypes<typeof CURRENCY>;

export interface AmountFilterKeys {
  amountFrom: string;
  amountTo: string;
}
